import React, { useMemo, useState } from 'react'
import { QueryBuilder } from '@mui/icons-material'

import { Container, HeadItem, TopLine, Name, Count, Meta } from './styles'
import { AppointmentsDrawer } from '../AppointmentsDrawer'
import { useSchedule } from '../../../hooks/ScheduleContext'
import { useEmployee } from '../../../store/schedule/useEmployee'
import { useThemes } from '../../../providers/theme'

/** Os turnos vem da API em segundos a partir da meia-noite. */
function paraHora(segundos) {
  if (segundos === null || segundos === undefined) return ''

  const total = Math.floor(Number(segundos) / 60)
  const hora = String(Math.floor(total / 60)).padStart(2, '0')
  const minuto = String(total % 60).padStart(2, '0')

  return `${hora}:${minuto}`
}

/**
 * "08:00–17:00", ou os dois turnos quando o profissional faz intervalo.
 *
 * Alguns cadastros tem turno com fim antes do inicio ("15:30-12:30"), o que
 * nao e horario nenhum. Em vez de mostrar um intervalo impossível, esses sao
 * deixados de fora; o cadastro do profissional e que precisa ser corrigido.
 */
function horarioDeAtendimento(shifts) {
  if (!Array.isArray(shifts) || !shifts.length) return ''

  return shifts
    .filter((turno) => Number(turno?.finishesAt) > Number(turno?.startsAt))
    .sort((a, b) => Number(a.startsAt) - Number(b.startsAt))
    .map((turno) => `${paraHora(turno.startsAt)}\u2013${paraHora(turno.finishesAt)}`)
    .join(' \u00b7 ')
}

export function Head() {
  const { getEmployees, getSchedules, getConfig } = useSchedule()
  const {
    employee: { size },
  } = useEmployee()

  const { theme } = useThemes()
  const [profissionalAberto, setProfissionalAberto] = useState(null)

  const employees = getEmployees()
  const schedules = getSchedules()
  const config = getConfig()

  // quantos agendamentos cada profissional tem no dia que esta na tela
  const totalPorProfissional = useMemo(() => {
    const lista = Array.isArray(schedules) ? schedules : []

    return lista.reduce((contagem, agendamento) => {
      const id = agendamento?.employeeId || agendamento?.roomId
      if (!id) return contagem

      contagem[id] = (contagem[id] || 0) + 1
      return contagem
    }, {})
  }, [schedules])

  const listaDeAgendamentos = Array.isArray(schedules) ? schedules : []

  const agendamentosDoAberto = profissionalAberto
    ? listaDeAgendamentos.filter(
        (agendamento) =>
          (agendamento?.employeeId || agendamento?.roomId) === profissionalAberto.id
      )
    : []

  return (
    <Container totalEmployees={employees.length} collumnSize={size}>
      <HeadItem>
        <QueryBuilder />
      </HeadItem>

      {!!employees &&
        employees.map((employee) => {
          const horario = horarioDeAtendimento(employee.shifts)
          // nas lojas em que a funcao nao esta cadastrada, ela costuma vir
          // dentro do proprio nome; ai mostramos so o horario
          const detalhe = [employee.jobTitle, horario].filter(Boolean).join(' · ')

          return (
            <HeadItem key={employee.id} title={employee.name}>
              <TopLine>
                <Name>{employee.name}</Name>
                <Count
                  type="button"
                  title={
                    totalPorProfissional[employee.id]
                      ? 'Ver os agendamentos do dia'
                      : 'Sem agendamentos no dia'
                  }
                  disabled={!totalPorProfissional[employee.id]}
                  onClick={(evento) => {
                    evento.stopPropagation()
                    setProfissionalAberto(employee)
                  }}
                >
                  {totalPorProfissional[employee.id] || 0}
                </Count>
              </TopLine>
              {!!detalhe && <Meta>{detalhe}</Meta>}
            </HeadItem>
          )
        })}

      {!!profissionalAberto && (
        <AppointmentsDrawer
          titulo={profissionalAberto.name}
          date={config.date}
          theme={theme}
          appointments={agendamentosDoAberto}
          onClose={() => setProfissionalAberto(null)}
        />
      )}
    </Container>
  )
}
